import { useAccountSettings, useAuth } from "../../hooks";
import { IPageTabNavLink } from "../../interfaces-and-types";
import { View } from "./View";

export const PageTabNavLinks = (props: {
  pageTabNavLinks: IPageTabNavLink[];
  boundedUnderline?: boolean;
  className?: string;
}) => {
  // const location = useLocation();
  const { active_tenant_id } = useAuth();
  const { data } = useAccountSettings();

  return (
    <View
      {...props}
      active_tenant_id={active_tenant_id}
      activeTenantHandle={data?.merchant_handle}
    />
  );
};
